<template>
  <!-- 模板部分无新增修改，保留原有内容 -->
  <div class="detail_layout">
    <div class="detail_body">
      <div class="detail_body_top">
        <mt-swipe :show-indicators="false" v-if="detailinfo.picUrls && detailinfo.picUrls.length">
          <mt-swipe-item v-for="(item, index) in detailinfo.picUrls" :key="index">
            <img
                :src="getImageUrl(item)"
                alt=""
                width="100%"
                height="100%"
                v-if="getImageUrl(item)"
            />
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <div class="detail-content-wrap">
        <div class="line"></div>
        <div class="coupon">
          <div class="dashed-line coupon-line"></div>
        </div>
        <div class="detail-content">
          <div class="discount-info">
            <template v-if="detailinfo.goodsName === '京东、天猫电子券各一张'">
              <img class="pic" :src="require('@/static/images/vip_discounts/banner/jd_A.png')">
              <div class="discount-name">京东超市京东E卡</div>
              <div class="discount-amount">
                <span>10</span>元
                <div class="discount-count">X 1张</div>
              </div>
              <div class="spacer">
                <div class="line"></div>
              </div>
              <img class="pic" :src="require('@/static/images/vip_discounts/banner/tm_A.png')">
              <div class="discount-name">天猫超市电子券</div>
              <div class="discount-amount">
                <span>10</span>元
                <div class="discount-count">X 1张</div>
              </div>
            </template>
            <template v-else>
              <img
                  class="pic"
                  :src="getImageUrl(detailinfo.profilePicture)"
                  v-if="detailinfo.profilePicture && getImageUrl(detailinfo.profilePicture)"
              />
              <div class="discount-name">{{ detailinfo.goodsName || '' }}</div>
              <div class="discount-amount">
                <span>{{ detailinfo.cardAmount || 0 }}</span>元
                <div class="discount-count">X {{ detailinfo.cardNum || 0 }}张</div>
              </div>
            </template>

            <div class="actions-btn"
                 :class="{
                   'has-tmall-btn': isShowTmallBtn,
                   'has-jd-btn': isShowJdBtn,
                   'has-other-btn': isShowOtherPhoneBtn,
                   'has-both-btn': (isShowTmallBtn && isShowJdBtn) || (isShowTmallBtn && isShowOtherPhoneBtn) || (isShowJdBtn && isShowOtherPhoneBtn),
                   'has-multi-btn': isShowTmallBtn && isShowJdBtn && isShowOtherPhoneBtn
                 }">
              <div class="btn" @click="toRecordsClick()">
                <span>领用记录</span>
              </div>
              <div
                  class="btn"
                  @click="toUseClick(detailinfo)"
                  :class="{ 'discount-received': detailinfo.useStatus === '1' }"
              >
                <span v-if="detailinfo.goodsType != 1">{{ detailinfo.useStatus | useBtnText }}</span>
                <span v-else>{{ detailinfo.useStatus | useBtnTe }}</span>
              </div>
              <div
                  class="btn"
                  @click="openTmallAccountModal()"
                  v-if="isShowTmallBtn"
              >
                <span>绑定天猫号</span>
              </div>
              <div
                  class="btn"
                  @click="openJdAccountModal()"
                  v-if="isShowJdBtn"
              >
                <span>绑定京东号</span>
              </div>
              <div
                  class="btn"
                  @click="openOtherPhoneModal()"
                  v-if="isShowOtherPhoneBtn"
              >
                <span>绑定手机号</span>
              </div>
            </div>
          </div>
          <div class="dashed-line"></div>
          <div class="discription">
            <div class="section-title">使用说明</div>
            <p class="desc" v-html="contents"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 权益确认弹窗 -->
    <modal
        :key="popupKey"
        :visible="popupVisible"
        title="权益确认"
        :isCancelBtn="false"
        @onCancel="cancelModalClick"
        classStyles="detail_modal"
    >
      <template #modal_body>
        <div>
          <p class="detail_modal_label">您选择的权益为</p>
          <p class="detail_modal_content">
            <span>{{ detailinfo.goodsName || '' }}&nbsp;&nbsp;</span>
            <span>{{ detailinfo.cardNum || 0 }}张&nbsp;&nbsp;</span>
            <span>{{ detailinfo.cardAmount || 0 }}元</span>
            <span>券</span>
          </p>
          <div class="detail_modal_okbtn" @click.stop="okBtnClick"> 确认使用</div>
          <div class="detail_modal_cancelbtn" @click.stop="cancelModalClick"> 我再想想</div>
        </div>
      </template>
    </modal>

    <!-- 库存提示弹窗 -->
    <modal
        :visible="stockPopupVisible"
        title="温馨提示"
        :isCancelBtn="false"
        @onCancel="closeStockMsg"
        class="home_msg_modal"
    >
      <template #modal_body>
        <p class="home_msg_modal_content">领取太火爆，正在加急补货</p>
        <div class="home_login_modal_btn" @click.stop="closeStockMsg"> 知道了</div>
      </template>
    </modal>

    <!-- 天猫账号绑定弹窗 -->
    <modal
        :visible="tmallAccountModalVisible"
        :title="tmallModalTitle"
        :isCancelBtn="false"
        @onCancel="closeTmallAccountModal"
        :classStyles="isShandongRegion ? 'detail_modal tmall_modal_shandong' : 'detail_modal'"
    >
      <template #modal_body>
        <div class="tmall-account-modal">
          <input
              v-model="account"
              type="text"
              placeholder="请输入天猫/淘宝账号"
              class="tmall-account-input"
          />
          <!-- 山东区域：更换账号限制提示 -->
          <div class="account-change-tip" v-if="isShandongRegion">
            <span class="tip-dot">!</span>
            <span>温馨提示：更换账号90天内仅允许修改一次，请确认无误后再保存</span>
          </div>
          <div class="detail_modal_okbtn" :class="{ 'is-disabled': isSaving }" @click.stop="saveTmallAccount">
            {{ isSaving ? '保存中...' : '保存' }}
          </div>
          <div class="detail_modal_cancelbtn" @click.stop="closeTmallAccountModal"> 取消</div>
        </div>
      </template>
    </modal>

    <!-- 京东账号绑定弹窗 -->
    <modal
        :visible="jdAccountModalVisible"
        title="绑定京东手机号"
        :isCancelBtn="false"
        @onCancel="closeJdAccountModal"
        classStyles="detail_modal"
    >
      <template #modal_body>
        <div class="jd-account-modal">
          <input
              v-model="account"
              type="tel"
              placeholder="请输入11位京东绑定手机号"
              class="jd-account-input"
              maxlength="11"
              inputmode="numeric"
          />
          <!-- 错误提示 -->
          <div class="error-msg" v-if="jdErrorMsg">{{ jdErrorMsg }}</div>
          <div class="detail_modal_okbtn" :class="{ 'is-disabled': isSavingJd }" @click.stop="saveJdAccount">
            {{ isSavingJd ? '保存中...' : '保存' }}
          </div>
          <div class="detail_modal_cancelbtn" @click.stop="closeJdAccountModal"> 取消</div>
        </div>
      </template>
    </modal>

    <!-- 其他商品（唯品会/沃尔玛/屈臣氏）手机号绑定弹窗 -->
    <modal
        :visible="otherPhoneModalVisible"
        :title="otherPhoneModalTitle"
        :isCancelBtn="false"
        @onCancel="closeOtherPhoneModal"
        classStyles="detail_modal"
    >
      <template #modal_body>
        <div class="jd-account-modal">
          <input
              v-model="account"
              type="tel"
              placeholder="请输入11位绑定手机号"
              class="jd-account-input"
              maxlength="11"
              inputmode="numeric"
          />
          <!-- 错误提示 -->
          <div class="error-msg" v-if="otherPhoneErrorMsg">{{ otherPhoneErrorMsg }}</div>
          <div class="detail_modal_okbtn" :class="{ 'is-disabled': isSavingOtherPhone }" @click.stop="saveOtherPhoneAccount">
            {{ isSavingOtherPhone ? '保存中...' : '保存' }}
          </div>
          <div class="detail_modal_cancelbtn" @click.stop="closeOtherPhoneModal"> 取消</div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import modal from '../../../components/modal.vue'
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  components: {
    modal
  },
  data() {
    return {
      topimgsrc: '',
      detailinfo: {
        picUrls: [],
        profilePicture: '',
        goodsName: '',
        cardAmount: 0,
        cardNum: 0,
        useStatus: '',
        goodsId: '',
        id: ''
      },
      popupVisible: false,
      popupKey: 0,
      id: '',
      outCouponId: '',
      stockPopupVisible: false,
      // 天猫账号相关
      tmallAccountModalVisible: false,
      isSaving: false,
      isCheckingTmallAccount: false,
      isCheckTmall: false,
      // 京东账号相关
      jdAccountModalVisible: false,
      account: '',
      isSavingJd: false,
      isCheckingJdAccount: false,
      isCheckJd: false,
      jdErrorMsg: '',
      // 其他商品（唯品会/沃尔玛/屈臣氏）手机号相关
      otherPhoneModalVisible: false,
      otherPhoneModalTitle: '',
      isSavingOtherPhone: false,
      isCheckingOtherPhone: false,
      isCheckOtherPhone: false,
      otherPhoneErrorMsg: ''
    }
  },
  mounted() {
    const id = this.$route.params.id
    const outCouponId = this.$route.params.outCouponId
    this.id = id || localStorage.getItem('goodsId')
    this.outCouponId = outCouponId
    this.getdetail(this.id, outCouponId)

    this.$nextTick(() => {
      if (this.isShowTmallBtn) {
        this.queryTmallAccount()
      }
      if (this.isShowJdBtn) {
        this.queryAccount()
      }
      if (this.isShowOtherPhoneBtn) {
        this.queryOtherPhoneAccount()
      }
    })
  },
  computed: {
    ...mapState(['loginInfo']),
    contents() {
      return this.detailinfo.useMethod || ''
    },
    // 是否山东区域（regionNo = 37）
    isShandongRegion() {
      const regionNo = this.detailinfo.regionNo || this.$route.params.regionNo || localStorage.getItem('regionNo')
      return String(regionNo) === '37'
    },
    // 天猫账号弹窗标题：山东区域为红色提示语
    tmallModalTitle() {
      return this.isShandongRegion
          ? '请输入与订购权益手机号码绑定的常用淘宝账号'
          : '绑定淘宝/天猫账号'
    },
    isShowTmallBtn() {
      const goodsName = this.detailinfo.goodsName || ''
      // 山东区域仅保留天猫超市电子券的绑定账号功能
      if (this.isShandongRegion) {
        return goodsName === '天猫超市电子券'
      }
      return goodsName === '京东、天猫电子券各一张' || goodsName === '天猫超市电子券'
    },
    isShowJdBtn() {
      const goodsName = this.detailinfo.goodsName || ''
      // 山东区域不展示绑定京东号
      if (this.isShandongRegion) return false
      return goodsName === '京东超市京东E卡' || goodsName === '京东、天猫电子券各一张'
    },
    // 新增：判断是否显示唯品会/沃尔玛/屈臣氏手机号绑定按钮
    isShowOtherPhoneBtn() {
      const goodsId = this.detailinfo.goodsId || ''
      const goodsName = this.detailinfo.goodsName || ''
      // 山东区域不展示绑定手机号
      if (this.isShandongRegion) return false
      // 匹配goodsId 3/4/9 或者对应的商品名称
      return ['3', '4', '9'].includes(goodsId) ||
          ['唯品会唯品卡', '沃尔玛电子券', '屈臣氏E-FUN卡', '屈臣氏电子券'].includes(goodsName)
    }
  },
  filters: {
    useBtnTe(val) {
      if (!val) return '下月使用'
      switch (val) {
        case '0':
          return '去激活'
        case '1':
          return '已激活'
        case '2':
          return '下月使用'
        case '3':
          return '领取'
        case '4':
          return '已领取'
        default:
          return '下月使用'
      }
    },
    useBtnText(val) {
      if (!val) return '领取'
      switch (val) {
        case '2':
          return '下月使用'
        case '1':
          return '已领取'
        case '4':
          return '已领取'
        default:
          return '领取'
      }
    }
  },
  methods: {
    // ========== 新增：获取适配接口的商品名称 ==========
    getAdaptedGoodsName(type) {
      const originalName = this.detailinfo.goodsName || ''
      // 双券商品适配：根据类型返回对应单品名称
      if (originalName === '京东、天猫电子券各一张') {
        if (type === 'tmall') return '天猫超市电子券'
        if (type === 'jd') return '京东超市京东E卡'
      }
      // 其他商品返回原名称
      return originalName
    },
    // ========== 新增结束 ==========

    getdetail(id, outCouponId) {
      if (id) localStorage.setItem('goodsId', id)
      const goodsId = id || localStorage.getItem('goodsId')
      if (!goodsId) {
        this.$toast({message: '商品ID缺失，无法获取详情', duration: 1500})
        return
      }

      this.post(this.apis.findGoodsDetail, {
        goodsId,
        memberId: this.loginInfo.id,
        outCouponId,
        spn: localStorage.getItem('spn')
      })
          .then((res) => {
            if (res.data.code === '0') {
              const data = res.data.data || {}
              this.detailinfo = {
                ...this.detailinfo,
                ...data,
                picUrls: data.picUrl ? data.picUrl.split(',').filter(item => item.trim()) : [],
                useStatus: data.useStatus.toString(),
                goodsId: data.goodsId || data.id || goodsId,
                id: data.id || goodsId
              }
              if (this.detailinfo.useMethod) {
                this.detailinfo.useMethod = this.detailinfo.useMethod.replace(/\n/g, '<br>')
              }
              console.log('商品详情获取成功：', this.detailinfo)
              console.log('是否显示天猫按钮：', this.isShowTmallBtn)
              console.log('是否显示京东按钮：', this.isShowJdBtn)
              console.log('是否显示其他手机号按钮：', this.isShowOtherPhoneBtn)
            } else {
              this.$toast({message: res.data.message || '获取商品详情失败', duration: 1500})
            }
          })
          .catch((error) => {
            console.error('获取商品详情异常：', error)
            handleRequestError(this, error)
          })
    },

    getImageUrl(filename) {
      if (!filename || filename.trim() === '') return ''
      try {
        return require(`@/static/images/vip_discounts/${filename.trim()}`)
      } catch (e) {
        console.warn('图片加载失败，文件不存在:', filename, e)
        return ''
      }
    },

    showStockMsg() {
      this.stockPopupVisible = true
    },
    closeStockMsg() {
      this.stockPopupVisible = false
    },

    // 天猫账号领取前校验
    async checkTmallAccountIsMaintained() {
      if (this.isCheckingTmallAccount) return false // 防止重复请求，返回false中断流程
      this.isCheckingTmallAccount = true
      console.log('领取操作：调用天猫账号校验接口')

      try {
        // ========== 修改点1：使用适配后的商品名称 ==========
        const adaptedGoodsName = this.getAdaptedGoodsName('tmall')
        const res = await this.post(this.apis.queryAccount, {
          memberId: this.loginInfo.id,
          goodsId: this.detailinfo.goodsId,
          goodsName: adaptedGoodsName // 传适配后的名称
        })
        // ========== 修改结束 ==========
        this.isCheckingTmallAccount = false

        this.isCheckTmall = res.data.data.isCheck === true || res.data.data.isCheck === 'true'
        console.log('领取操作-天猫校验接口返回：', res.data)
        console.log('领取操作-是否需要校验天猫账号：', this.isCheckTmall)

        if (res.data.code === '0') {
          if (this.isCheckTmall) {
            const hasAccount = !!res.data.data?.account?.trim()
            this.account = res.data.data?.account || ''
            console.log('领取操作-天猫账号是否已维护：', hasAccount)
            // 核心修复：无论是否有账号，都返回true，仅通过后续逻辑判断是否弹框
            return true
          } else {
            console.log('领取操作-无需校验天猫账号，直接允许')
            return true
          }
        }
        // 接口返回非0码，默认需要维护账号
        return false
      } catch (error) {
        this.isCheckingTmallAccount = false
        console.error('领取操作-天猫校验接口异常：', error)
        handleRequestError(this, error)
        return false // 异常时返回false，触发绑定弹窗
      }
    },

    // 京东账号领取前校验
    async checkJdAccountIsMaintained() {
      if (this.isCheckingJdAccount) return false // 防止重复请求，返回false中断流程
      this.isCheckingJdAccount = true
      console.log('领取操作：调用京东账号校验接口')

      try {
        // ========== 修改点2：使用适配后的商品名称 ==========
        const adaptedGoodsName = this.getAdaptedGoodsName('jd')
        const res = await this.post(this.apis.queryAccount, {
          memberId: this.loginInfo.id,
          goodsName: adaptedGoodsName // 传适配后的名称
        })
        // ========== 修改结束 ==========
        this.isCheckingJdAccount = false

        this.isCheckJd = res.data.data.isCheck === true || res.data.data.isCheck === 'true'
        console.log('领取操作-京东校验接口返回：', res.data)
        console.log('领取操作-是否需要校验京东账号：', this.isCheckJd)

        if (res.data.code === '0') {
          if (this.isCheckJd) {
            const hasAccount = !!res.data.data?.account?.trim()
            this.account = res.data.data?.account || ''
            console.log('领取操作-京东账号是否已维护：', hasAccount)
            // 核心修复：无论是否有账号，都返回true，仅通过后续逻辑判断是否弹框
            return true
          } else {
            console.log('领取操作-无需校验京东账号，直接允许')
            return true
          }
        }
        // 接口返回非0码，默认需要维护账号
        return false
      } catch (error) {
        this.isCheckingJdAccount = false
        console.error('领取操作-京东校验接口异常：', error)
        handleRequestError(this, error)
        return false // 异常时返回false，触发绑定弹窗
      }
    },

    // 新增：唯品会/沃尔玛/屈臣氏手机号领取前校验
    async checkOtherPhoneIsMaintained() {
      if (this.isCheckingOtherPhone) return false // 防止重复请求，返回false中断流程
      this.isCheckingOtherPhone = true
      console.log('领取操作：调用其他商品手机号校验接口')

      try {
        const res = await this.post(this.apis.queryAccount, {
          memberId: this.loginInfo.id,
          goodsName: this.detailinfo.goodsName
        })
        this.isCheckingOtherPhone = false

        this.isCheckOtherPhone = res.data.data.isCheck === true || res.data.data.isCheck === 'true'
        console.log('领取操作-其他商品手机号校验接口返回：', res.data)
        console.log('领取操作-是否需要校验其他商品手机号：', this.isCheckOtherPhone)

        if (res.data.code === '0') {
          if (this.isCheckOtherPhone) {
            const hasAccount = !!res.data.data?.account?.trim()
            this.account = res.data.data?.account || ''
            console.log('领取操作-其他商品手机号是否已维护：', hasAccount)
            return hasAccount
          } else {
            console.log('领取操作-无需校验其他商品手机号，直接允许')
            return true
          }
        }
        // 接口返回非0码，默认需要维护账号
        return false
      } catch (error) {
        this.isCheckingOtherPhone = false
        console.error('领取操作-其他商品手机号校验接口异常：', error)
        handleRequestError(this, error)
        return false // 异常时返回false，触发绑定弹窗
      }
    },

    // 核心优化：完善领取校验逻辑，确保未维护账号时强制打开绑定弹窗
    async toUseClick(item) {
      console.log('进入领取逻辑：', item)
      console.log('当前商品是否为天猫商品：', this.isShowTmallBtn)
      console.log('当前商品是否为京东商品：', this.isShowJdBtn)
      console.log('当前商品是否为其他手机号商品：', this.isShowOtherPhoneBtn)

      // 基础校验
      if (!item || !item.id || !item.goodsId) {
        this.$toast({message: '商品信息不完整，无法领取', duration: 1500})
        return
      }
      if (['1', '4', '2'].includes(item.useStatus)) {
        console.log('商品状态不允许领取：', item.useStatus)
        return
      }
      // 库存限制校验
      const limitGoods = ['锅圈食汇', '大润发电子券', '叮咚买菜']
      if (limitGoods.some(name => item.goodsName.includes(name)) ||
          (item.regionNo === '37' && item.goodsName === '屈臣氏电子券')) {
        this.showStockMsg()
        return
      }

      let canReceive = true
      const isDoubleCoupon = item.goodsName === '京东、天猫电子券各一张' // 双券商品标记
      const isJdSingleCoupon = item.goodsName === '京东超市京东E卡' // 京东单独卡券标记
      const isOtherPhoneCoupon = this.isShowOtherPhoneBtn // 其他手机号商品标记

      // 1. 双券商品：先校验天猫 → 再校验京东
      // 山东区域已去除绑定账号功能（仅保留天猫超市电子券），故不做账号校验
      if (isDoubleCoupon && !this.isShandongRegion) {
        // 第一步：校验天猫账号
        const tmallCheckResult = await this.checkTmallAccountIsMaintained()
        console.log('领取操作-双券商品-天猫校验结果：', tmallCheckResult)

        // 校验接口返回成功，但账号未维护
        if (tmallCheckResult && this.isCheckTmall && !this.account.trim()) {
          this.tmallAccountModalVisible = true
          this.$toast({
            message: '请先绑定淘宝/天猫账号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }

        // 校验接口返回失败（异常）
        if (!tmallCheckResult) {
          this.tmallAccountModalVisible = true
          this.$toast({
            message: '请先绑定淘宝/天猫账号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }

        // 第二步：校验京东账号（天猫校验通过后）
        const jdCheckResult = await this.checkJdAccountIsMaintained()
        console.log('领取操作-双券商品-京东校验结果：', jdCheckResult)

        // 校验接口返回成功，但账号未维护
        if (jdCheckResult && this.isCheckJd && !this.account.trim()) {
          this.jdAccountModalVisible = true
          this.$toast({
            message: '请先绑定京东手机号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }

        // 校验接口返回失败（异常）
        if (!jdCheckResult) {
          this.jdAccountModalVisible = true
          this.$toast({
            message: '请先绑定京东手机号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }
      }
      // 2. 京东单独卡券：只校验京东账号
      else if (isJdSingleCoupon && !this.isShandongRegion) {
        const jdCheckResult = await this.checkJdAccountIsMaintained()
        console.log('领取操作-京东单独卡券-京东校验结果：', jdCheckResult)

        if (jdCheckResult && this.isCheckJd && !this.account.trim()) {
          this.jdAccountModalVisible = true
          this.$toast({
            message: '请先绑定京东手机号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }

        if (!jdCheckResult) {
          this.jdAccountModalVisible = true
          this.$toast({
            message: '请先绑定京东手机号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }
      }
      // 3. 天猫单独卡券：只校验天猫账号
      else if (this.isShowTmallBtn) {
        const tmallCheckResult = await this.checkTmallAccountIsMaintained()
        console.log('领取操作-天猫单独卡券-天猫校验结果：', tmallCheckResult)

        if (tmallCheckResult && this.isCheckTmall && !this.account.trim()) {
          this.tmallAccountModalVisible = true
          this.$toast({
            message: '请先绑定淘宝/天猫账号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }

        if (!tmallCheckResult) {
          this.tmallAccountModalVisible = true
          this.$toast({
            message: '请先绑定淘宝/天猫账号后再领取权益',
            duration: 2000,
            type: 'error'
          })
          return false
        }
      }
      // 4. 其他手机号商品（唯品会/沃尔玛/屈臣氏）：校验手机号
      else if (isOtherPhoneCoupon) {
        canReceive = await this.checkOtherPhoneIsMaintained()
        console.log('领取操作-其他商品-手机号校验结果：', canReceive)

        if (!canReceive) {
          this.openOtherPhoneModal()
          this.$toast({
            message: `请先绑定${this.getOtherPhoneModalTitle()}手机号后再领取权益`,
            duration: 2000,
            type: 'error'
          })
          return false
        }
      }

      // 所有校验通过，打开确认弹窗
      console.log('领取操作-所有校验通过，打开确认弹窗')
      this.openReceivePopup()
    },

    // 新增：获取其他商品手机号弹窗标题
    getOtherPhoneModalTitle() {
      const goodsName = this.detailinfo.goodsName || ''
      if (goodsName.includes('唯品会')) return '唯品会'
      if (goodsName.includes('沃尔玛')) return '沃尔玛'
      if (goodsName.includes('屈臣氏')) return '屈臣氏'
      return ''
    },

    openReceivePopup() {
      const spn = localStorage.getItem('spn')
      const regionNo = this.detailinfo.regionNo || this.$route.params.regionNo || localStorage.getItem('regionNo')
      const isGoodsType1 = String(this.detailinfo.goodsType || this.$route.params.goodsType) === '1'
      const isRegion37 = String(regionNo) === '37'

      console.log('openReceivePopup-判断条件：', {
        spn,
        regionNo,
        isGoodsType1,
        isRegion37,
        condition: !isGoodsType1 || (isRegion37 && isGoodsType1)
      })

      this.$nextTick(() => {
        this.popupKey += 1
        this.popupVisible = true
        console.log('openReceivePopup-打开弹窗，popupVisible:', this.popupVisible)
      })

      if (!isGoodsType1 || (isRegion37 && isGoodsType1)) {
        this.get(this.apis.findGoodsRightsCount + '?spn=' + spn)
            .then((res) => {
              console.log('openReceivePopup-查询领取次数结果：', res.data)
              if (res.data.code !== '0') {
                this.$toast({message: res.data.message || '查询领取次数失败', duration: 1500})
              }
            })
            .catch((error) => {
              console.error('openReceivePopup-查询领取次数异常：', error)
              handleRequestError(this, error)
            })
      }
    },

    okBtnClick() {
      console.log('点击确认领取，执行兑换逻辑')
      // 优先使用接口返回的 goodsType/regionNo（findGoodsDetail），避免路由参数丢失或不一致导致河南中粮误走下单
      const goodsType = String(this.detailinfo.goodsType || this.$route.params.goodsType)
      const regionNo = this.detailinfo.regionNo || this.$route.params.regionNo || localStorage.getItem('regionNo')

      if (goodsType === '1') {
        regionNo === '37' ? this.exchangeCode() : this.exchangeCode2()
      } else {
        this.exchangeCode()
      }
      this.popupVisible = false
    },

    exchangeCode() {
      const params = {
        regionNo: this.detailinfo.regionNo || this.$route.params.regionNo || localStorage.getItem('regionNo'),
        num: this.$route.params.num || this.detailinfo.cardNum || 1,
        goodsId: this.detailinfo.goodsId || this.detailinfo.id,
        memberId: this.loginInfo.id,
        productCatalogId: this.detailinfo.id || this.detailinfo.goodsId,
        phone: this.loginInfo.mobile || '',
        spn: localStorage.getItem('spn')
      }

      console.log('调用兑换接口（exchangeCode），参数：', params)

      if (!params.memberId || !params.goodsId || !params.regionNo) {
        this.$toast({message: '领取参数不完整，无法兑换', duration: 1500})
        return
      }

      this.post(this.apis.couponCreateAndGetCode, params)
          .then((res) => {
            if (res.data.code === '0') {
              this.$toast({message: '兑换成功', duration: 1500})
              const orderId = res.data.data
              console.log('兑换成功，订单ID：', orderId)
              this.$router.push({
                name: 'receiveDiscount',
                params: {
                  orderId,
                  couponId: this.detailinfo.id,
                  memberId: params.memberId,
                  goodsId: params.goodsId,
                  regionNo: params.regionNo
                }
              })
            } else {
              this.$toast({message: res.data.message || '兑换失败', duration: 1500})
              console.error('兑换失败：', res.data)
            }
          })
          .catch((error) => {
            console.error('兑换接口（exchangeCode）异常：', error)
            handleRequestError(this, error)
          })
    },

    exchangeCode2() {
      const params = {
        regionNo: this.detailinfo.regionNo || this.$route.params.regionNo || localStorage.getItem('regionNo'),
        num: this.$route.params.num || this.detailinfo.cardNum || 1,
        cardgoodsId: this.detailinfo.id || this.detailinfo.goodsId,
        memberId: this.loginInfo.id,
        productCatalogId: this.detailinfo.id || this.detailinfo.goodsId,
        phone: this.loginInfo.mobile || '',
        cardAmount: this.detailinfo.cardAmount || 0,
        spn: localStorage.getItem('spn')
      }

      console.log('调用兑换接口（exchangeCode2），参数：', params)

      if (!params.memberId || !params.cardgoodsId || !params.regionNo) {
        this.$toast({message: '领取参数不完整，无法兑换', duration: 1500})
        return
      }

      if (params.regionNo === '37') {
        this.get(this.apis.findGoodsRightsCount + '?spn=' + params.spn)
            .then((res) => {
              if (res.data.code !== '0') {
                this.$toast({message: res.data.message || '查询领取次数失败', duration: 1500})
                return
              }
              this.executeOriginalExchangeCode2(params)
            })
            .catch((error) => {
              console.error('查询领取次数异常：', error)
              handleRequestError(this, error)
              this.executeOriginalExchangeCode2(params)
            })
      } else {
        this.executeOriginalExchangeCode2(params)
      }
    },

    executeOriginalExchangeCode2(params) {
      this.post(this.apis.getCoupon, params)
          .then((res) => {
            if (res.data.code === '0') {
              this.$toast({message: '兑换成功', duration: 1500})
              console.log('兑换成功（exchangeCode2）：', res.data)
              this.getdetail(this.detailinfo.id, this.outCouponId)
            } else {
              this.$toast({message: res.data.message || '兑换失败', duration: 1500})
              console.error('兑换失败（exchangeCode2）：', res.data)
            }
          })
          .catch((error) => {
            console.error('兑换接口（exchangeCode2）异常：', error)
            handleRequestError(this, error)
          })
    },

    // 天猫账号相关方法
    openTmallAccountModal() {
      console.log('手动点击：打开天猫账号绑定弹窗')
      this.tmallAccountModalVisible = true
      this.queryTmallAccount()
    },

    closeTmallAccountModal() {
      console.log('关闭天猫账号弹窗')
      this.tmallAccountModalVisible = false
    },

    queryTmallAccount() {
      if (!this.loginInfo.id) {
        this.$toast({message: '用户未登录，无法查询天猫账号', duration: 1500})
        return
      }

      console.log('查询天猫账号：仅用于弹窗回显')
      // ========== 修改点3：查询天猫账号时使用适配后的名称 ==========
      const adaptedGoodsName = this.getAdaptedGoodsName('tmall')
      this.post(this.apis.queryAccount, {
        memberId: this.loginInfo.id,
        goodsName: adaptedGoodsName
      })
          // ========== 修改结束 ==========
          .then((res) => {
            if (res.data.code === '0') {
              this.account = res.data.data?.account || ''
              console.log('查询天猫账号成功（回显）：', this.account)
            } else {
              this.$toast({message: res.data.message || '查询天猫账号失败', duration: 1500})
            }
          })
          .catch((error) => {
            console.error('查询天猫账号异常（回显）：', error)
            handleRequestError(this, error)
          })
    },

    saveTmallAccount() {
      if (this.isSaving) return
      const account = this.account.trim()
      if (!account) {
        this.$toast({message: '请输入天猫/淘宝账号', duration: 1500})
        return
      }

      this.isSaving = true
      // ========== 修改点4：保存天猫账号时使用适配后的名称 ==========
      const adaptedGoodsName = this.getAdaptedGoodsName('tmall')
      const params = {
        memberId: this.loginInfo.id,
        account: account,
        goodsName: adaptedGoodsName
      }
      // ========== 修改结束 ==========

      this.post(this.apis.updateAccount, params)
          .then((res) => {
            this.isSaving = false
            if (res.data.code === '0') {
              this.$toast({message: '淘宝/天猫账号绑定成功！', duration: 1500})
              this.closeTmallAccountModal()
              this.queryTmallAccount()
            } else if(res.data.code === '9999') {
              this.$toast({message: res.data.message || '淘宝/天猫账号绑定失败', duration: 1500})
            }
          })
          .catch((error) => {
            this.isSaving = false
            console.error('保存天猫账号异常：', error)
            handleRequestError(this, error)
            this.$toast({message: '网络异常，天猫账号保存失败', duration: 1500})
          })
    },

    // 京东账号相关方法
    openJdAccountModal() {
      console.log('手动点击：打开京东手机号绑定弹窗')
      this.jdAccountModalVisible = true
      this.queryAccount()
      this.jdErrorMsg = "";
    },

    closeJdAccountModal() {
      console.log('关闭京东手机号弹窗')
      this.jdAccountModalVisible = false
      this.jdErrorMsg = "";
    },

    queryAccount() {
      if (!this.loginInfo.id) {
        this.$toast({message: '用户未登录，无法查询京东手机号', duration: 1500})
        return
      }

      // ========== 修改点5：查询京东账号时使用适配后的名称 ==========
      const adaptedGoodsName = this.getAdaptedGoodsName('jd')
      console.log('查询京东手机号：仅用于弹窗回显，适配后名称：', adaptedGoodsName)

      this.post(this.apis.queryAccount, {
        memberId: this.loginInfo.id,
        goodsName: adaptedGoodsName
      })
          // ========== 修改结束 ==========
          .then((res) => {
            if (res.data.code === '0') {
              this.account = res.data.data?.account || ''
              console.log('查询京东手机号成功（回显）：', this.account)
            } else {
              this.$toast({message: res.data.message || '查询京东手机号失败', duration: 1500})
            }
          })
          .catch((error) => {
            console.error('查询京东手机号异常（回显）：', error)
            handleRequestError(this, error)
          })
    },

    saveJdAccount() {
      if (this.isSavingJd) return
      const phone = this.account.trim()

      // 1. 空值校验
      if (!phone) {
        this.jdErrorMsg = '请输入京东绑定手机号'
        return
      }

      // 2. 11位长度校验
      if (phone.length !== 11) {
        this.jdErrorMsg = '请输入11位有效手机号'
        return
      }

      // 3. 手机号格式校验
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(phone)) {
        this.jdErrorMsg = '请输入格式正确的手机号'
        return
      }
      // 清除错误信息
      this.jdErrorMsg = ''
      this.isSavingJd = true
      // ========== 修改点6：保存京东账号时使用适配后的名称 ==========
      const adaptedGoodsName = this.getAdaptedGoodsName('jd')
      const params = {
        memberId: this.loginInfo.id,
        account: phone,
        goodsName: adaptedGoodsName
      }
      // ========== 修改结束 ==========

      this.post(this.apis.updateAccount, params)
          .then((res) => {
            this.isSavingJd = false
            if (res.data.code === '0') {
              this.$toast({message: '京东手机号绑定成功！', duration: 1500, type: 'success'})
              this.closeJdAccountModal()
              this.queryAccount()
            } else {
              this.$toast({message: res.data.message || '京东手机号绑定失败', duration: 1500, type: 'error'})
            }
          })
          .catch((error) => {
            this.isSavingJd = false
            console.error('保存京东手机号异常：', error)
            handleRequestError(this, error)
            this.$toast({message: '网络异常，京东手机号保存失败', duration: 1500, type: 'error'})
          })
    },

    // 新增：其他商品（唯品会/沃尔玛/屈臣氏）手机号相关方法
    openOtherPhoneModal() {
      console.log('手动点击：打开其他商品手机号绑定弹窗')
      // 设置弹窗标题
      this.otherPhoneModalTitle = `绑定${this.getOtherPhoneModalTitle()}手机号`
      this.otherPhoneModalVisible = true
      this.queryOtherPhoneAccount()
      this.otherPhoneErrorMsg = "";
    },

    closeOtherPhoneModal() {
      console.log('关闭其他商品手机号弹窗')
      this.otherPhoneModalVisible = false
      this.otherPhoneErrorMsg = "";
    },

    queryOtherPhoneAccount() {
      if (!this.loginInfo.id) {
        this.$toast({message: '用户未登录，无法查询手机号', duration: 1500})
        return
      }

      console.log('查询其他商品手机号：仅用于弹窗回显')
      this.post(this.apis.queryAccount, {
        memberId: this.loginInfo.id,
        goodsName: this.detailinfo.goodsName
      })
          .then((res) => {
            if (res.data.code === '0') {
              this.account = res.data.data?.account || ''
              console.log('查询其他商品手机号成功（回显）：', this.account)
            } else {
              this.$toast({message: res.data.message || '查询手机号失败', duration: 1500})
            }
          })
          .catch((error) => {
            console.error('查询其他商品手机号异常（回显）：', error)
            handleRequestError(this, error)
          })
    },

    saveOtherPhoneAccount() {
      if (this.isSavingOtherPhone) return
      const phone = this.account.trim()

      // 1. 空值校验
      if (!phone) {
        this.otherPhoneErrorMsg = '请输入绑定手机号'
        return
      }

      // 2. 11位长度校验
      if (phone.length !== 11) {
        this.otherPhoneErrorMsg = '请输入11位有效手机号'
        return
      }

      // 3. 手机号格式校验
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(phone)) {
        this.otherPhoneErrorMsg = '请输入格式正确的手机号'
        return
      }
      // 清除错误信息
      this.otherPhoneErrorMsg = ''
      this.isSavingOtherPhone = true
      const params = {
        memberId: this.loginInfo.id,
        account: phone,
        goodsName: this.detailinfo.goodsName
      }

      this.post(this.apis.updateAccount, params)
          .then((res) => {
            this.isSavingOtherPhone = false
            if (res.data.code === '0') {
              this.$toast({
                message: `${this.getOtherPhoneModalTitle()}手机号绑定成功！`,
                duration: 1500,
                type: 'success'
              })
              this.closeOtherPhoneModal()
              this.queryOtherPhoneAccount()
            } else {
              this.$toast({
                message: res.data.message || `${this.getOtherPhoneModalTitle()}手机号绑定失败`,
                duration: 1500,
                type: 'error'
              })
            }
          })
          .catch((error) => {
            this.isSavingOtherPhone = false
            console.error('保存其他商品手机号异常：', error)
            handleRequestError(this, error)
            this.$toast({message: '网络异常，手机号保存失败', duration: 1500, type: 'error'})
          })
    },

    toRecordsClick() {
      this.$router.push({
        name: 'couponRecords',
        params: {
          memberId: this.loginInfo.id,
          goodsId: this.detailinfo.goodsId,
          regionNo: this.$route.params.regionNo,
          goodsType: this.$route.params.goodsType
        }
      })
    },
    cancelModalClick() {
      this.popupVisible = false
    }
  }

}
</script>

<style scoped lang="less">
// 样式部分保持不变
.detail_layout {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f3;
}

.detail_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  &_top {
    width: 100%;
    min-height: 300px;
    height: 380px;
  }
}

.detail_modal {
  &_label {
    color: #848484;
    padding: 16px 0px 0px;
  }

  &_content {
    color: #cd0c09;
    font-size: 32px;
    padding: 16px 0px 0px;
    margin: 24px 0px 50px;
  }

  // 手机端：主按钮高度 88px（≈44px）保证可点击区域，字号明确
  &_okbtn {
    width: 85%;
    margin: 32px auto 0;
    background-color: #cd0c09;
    border-radius: 44px;
    text-align: center;
    color: #fff;
    font-size: 30px;
    height: 88px;
    line-height: 88px;
    cursor: pointer;
    box-sizing: border-box;
    border: none;
    -webkit-tap-highlight-color: transparent;
    user-select: none;

    &:active {
      opacity: 0.85;
    }

    &:disabled,
    &.is-disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }

  // 手机端：次按钮同样保证可点击区域，颜色加深保证可见
  &_cancelbtn {
    width: 85%;
    margin: 16px auto 0;
    text-align: center;
    color: #999;
    font-size: 28px;
    height: 72px;
    line-height: 72px;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    user-select: none;

    &:active {
      opacity: 0.8;
    }
  }
}

.detail-content-wrap {
  padding: 0 24px;
  margin-top: -168px;
  padding-bottom: 50px;

  .detail-content {
    background: #fff;
    margin: 0 10px;
    margin-top: -2px;

    .discount-info {
      text-align: center;
      border-bottom: 1px dashed #d3d3d3;
      padding-bottom: 50px;
      position: relative;
      z-index: 1;
      background: #fff;

      .pic {
        border-radius: 100%;
        width: 100px;
        height: 100px;
        border: 1px solid #d9d9d9;
        display: block;
        margin: 0 auto;
      }

      .discount-name {
        font-size: 35px;
        margin-top: 16px;
        color: #000000;
        font-family: 'Alibaba PuHuiTi 2.0', 'Alibaba PuHuiTi 20', sans-serif;
        font-weight: normal;
        font-style: normal;
      }

      .discount-amount {
        color: #f96914;
        flex-shrink: 0;
        display: inline-flex;
        align-items: flex-end;
        justify-content: center;
        font-size: 28px;
        position: relative;
        margin-top: 24px;

        span {
          font-size: 80px;
          line-height: 1;
          font-weight: bold;
        }
      }

      .discount-count {
        width: 90px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #fb7019;
        border-radius: 24px 24px 24px 0px;
        color: #fff;
        font-size: 24px;
        position: absolute;
        right: -108px;
        top: 0;
      }

      .actions-btn {
        display: grid;
        grid-template-columns: repeat(2, 214px);
        gap: 44px;
        justify-content: center;
        margin-top: 36px;

        .btn {
          width: 214px;
          height: 56px;
          line-height: 56px;
          background: #ffffff;
          border-radius: 56px;
          border: 1px solid #fb7019;
          color: #fb7019;
          font-size: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &.has-tmall-btn {
          grid-template-columns: repeat(3, 180px);
          gap: 20px;

          .btn {
            width: 180px;
          }
        }

        &.has-jd-btn {
          grid-template-columns: repeat(3, 180px);
          gap: 20px;

          .btn {
            width: 180px;
          }
        }

        &.has-other-btn {
          grid-template-columns: repeat(3, 180px);
          gap: 20px;

          .btn {
            width: 180px;
          }
        }

        &.has-both-btn {
          grid-template-columns: repeat(4, 140px);
          gap: 16px;

          .btn {
            width: 140px;
            font-size: 24px;
          }
        }

        &.has-multi-btn {
          grid-template-columns: repeat(5, 120px);
          gap: 12px;

          .btn {
            width: 120px;
            font-size: 22px;
          }
        }
      }
    }

    .discription {
      padding: 24px 50px;

      .desc {
        font-size: 20px;
        color: #919191;
        line-height: 38px;
      }
    }

    .section-title {
      font-size: 32px;
      margin-bottom: 18px;
      position: relative;
      display: flex;
      align-items: center;

      &::before {
        content: '';
        width: 6px;
        height: 28px;
        background: #fb7019;
        margin-right: 14px;
        display: block;
      }
    }
  }
}

.line {
  height: 4px;
  background: #d9d9d9;
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.25);
}

.coupon {
  margin: 0 10px;
  overflow: hidden;
  padding-top: 80px;
  filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.1));
  position: relative;
  color: #fff;

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    z-index: -1;
    -webkit-mask: radial-gradient(circle at 20px 61%, transparent 20px, red 0) -20px;
  }

  .coupon-line {
    width: calc(100% - 50px);
    position: absolute;
    left: 25px;
    top: 48px;
  }
}

.dashed-line {
  height: 1px;
  background: repeating-linear-gradient(to right, #d3d3d3, #d3d3d3 6px, transparent 6px, transparent 12px);
}

.spacer {
  height: 80px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.line {
  width: 450px;
  height: 0px;
  border: 1px solid #f3f3f3;
}

.home_login {
  &_modal {
    width: 60%;
    padding: 16px 24px;
    border-radius: 24px;
    // 高度随内容自适应，避免内容溢出与下方关闭按钮重叠
    height: auto;
    min-height: 400px;

    &_title {
      width: 100%;
      font-size: 30px;
      color: #090606;
      text-align: center;
      font-weight: bold;
      padding-top: 40px;
    }

    &_btn {
      width: 85%;
      margin: 0 auto;
      background-color: #cd0c09;
      border-radius: 40px;
      height: 60px;
      text-align: center;
      color: #fff;
      line-height: 60px;
      margin-top: 24px;
      margin-top: 40px;
      font-size: 24px;
    }

    &_cancel {
      width: 56px;
      height: 56px;
      margin: 0 auto;
      margin-top: 150px;
    }
  }
}

.home_msg {
  &_modal {
    height: 300px;
    min-height: 300px;

    &_content {
      text-align: center;
      margin: 24px 0px;
    }
  }
}

.tmall-account-modal {
  .tmall-account-input {
    width: 85%;
    height: 88px;
    line-height: 88px;
    border: 1px solid #d3d3d3;
    border-radius: 44px;
    padding: 0 28px;
    margin: 24px auto;
    display: block;
    font-size: 30px;
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;

    &::placeholder {
      color: #bbb;
      font-size: 26px;
    }

    &:focus {
      outline: none;
      border-color: #fb7019;
      box-shadow: 0 0 8px rgba(251, 112, 25, 0.2);
    }
  }
}

.jd-account-modal {
  .jd-account-input {
    width: 85%;
    height: 88px;
    line-height: 88px;
    border: 1px solid #d3d3d3;
    border-radius: 44px;
    padding: 0 28px;
    margin: 24px auto;
    display: block;
    font-size: 30px;
    box-sizing: border-box;
    -webkit-appearance: none;
    appearance: none;

    &::placeholder {
      color: #bbb;
      font-size: 26px;
    }

    &:focus {
      outline: none;
      border-color: #fb7019;
      box-shadow: 0 0 8px rgba(251, 112, 25, 0.2);
    }
  }
}

.error-msg {
  color: #ff4444;
  font-size: 26px;
  text-align: center;
  margin: 15px auto;
  padding: 12px 20px;
  min-height: 50px;
  background-color: #fff5f5;
  border-radius: 12px;
  border: 1px solid #ffcdd2;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.1);
  max-width: 85%;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeInUp 0.3s ease-out;
  position: relative;
  padding-left: 50px;

  &::before {
    content: "!";
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    background-color: #ff4444;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
  }
}

// 更换账号限制提示（山东区域）
.account-change-tip {
  width: 85%;
  margin: 0 auto 12px;
  padding: 12px 20px;
  background-color: #fff8f0;
  border: 1px solid #ffd8b3;
  border-radius: 12px;
  color: #f96914;
  font-size: 24px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  .tip-dot {
    width: 24px;
    height: 24px;
    line-height: 24px;
    flex-shrink: 0;
    margin-right: 10px;
    border-radius: 50%;
    background-color: #f96914;
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
}

// 山东区域：天猫账号弹窗标题改为提示语（红色）
.tmall_modal_shandong {
  ::v-deep .home_login_modal_title {
    color: #cd0c09;
    font-size: 26px;
    line-height: 38px;
    font-weight: normal;
    padding: 24px 10px 0;
    white-space: normal;
    word-break: break-all;
  }
}
</style>